var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.017 6C7.193 6 6 7.08 6 8.5 6 9.89 7.157 11 8.947 11h.035C10.842 11 12 9.889 12 8.5 11.965 7.08 10.842 6 9.017 6zM6 14h5v15H6zM23.966 13c-2.828 0-4.724 2.634-4.724 2.634v-2.267H14V29h5.242v-8.73c0-.467.034-.934.172-1.268.38-.934 1.241-1.9 2.69-1.9 1.896 0 2.655 1.433 2.655 3.535V29H30v-8.964C30 15.234 27.414 13 23.966 13z"
  }))));
};

export default __webpack_public_path__ + "static/media/linkedin.2e3c44d2.svg";
export { SvgLinkedin as ReactComponent };